/* import __COLOCATED_TEMPLATE__ from './project-details-files-asset-item.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { showModal } from 'sh-www/utils/modal-controls';

class ProjectDetailsFilesAssetItem extends Component {
  @service session;

  get assetMenuDropdownOptions() {
    const menuOptions = [];

    if (this.args.asset.allow.update) {
      menuOptions.push({
        title: 'Remove from project',
        onClick: () => this.onRemoveFromProjectClicked(),
      });
    }

    return menuOptions;
  }

  @action
  onRemoveFromProjectClicked() {
    const { asset, removeAssetItem } = this.args;
    showModal(this, 'confirmation', {
      titleText: 'Remove file?',
      bodyText: `Are you sure you want to remove this file from this project?`,
      actionButtonText: 'Remove',
      cancelButtonText: 'Cancel',
      isShowCancelButton: true,
      confirmAction: () => {
        removeAssetItem.perform(asset);
      },
    });
  }
}

export default ProjectDetailsFilesAssetItem;
